import React from 'react'

const FormValidation = (WrappedForm, options) =>
class Form extends React.Component {
  constructor() {
    super()
    this.validate = this.validate.bind(this)
    this.submit = this.submit.bind(this)
    this.state = {
      errors: [],
      submitting: false,
      submitSuccessfull: false,
      submitFailed: false,
      validating: false,
      validationSuccessfull: false,
      validationFailed: false,
    }
  }

  setErrors(errors) {
    this.setState({
      errors,
    })
  }

  validate(data) {
    const validationFunc = options(this.props).submissionValidation
    const errors = validationFunc(data, options(this.props).optionalValidationData)
    this.setErrors(errors)
    return errors.length === 0
  }

  async submit(data, submitFunc) {
    this.setState({
      submitting: false,
      submitSuccessfull: false,
      submitFailed: false,
      validating: false,
      validationSuccessfull: false,
      validationFailed: false,
    })
    try {
      this.setState({ validating: true })
      if (this.validate(data)) {
        this.setState({ validating: false, validationSuccessfull: true, submitting: true })
        const response = await submitFunc(data).meta.action.payload
        this.setState({ submitting: false, submitSuccessfull: true })
        return response
      }
      this.setState({ validating: false, validationFailed: true })
      return false
    } catch (error) {
      let errors = error.errors
      if (!errors && error.message) errors = [error]
      else if (!errors && error.code === 404) errors = [{ error: 'Neexistuje' }]
      if (!Array.isArray(errors)) errors = [{ message: errors }]
      this.setErrors(errors)
      this.setState({ submitting: false, submitFailed: true })
      return false
    }
  }

  render() {
    let errorMessage = ''
    const errors = this.state && this.state.errors
    if (errors && errors.length) {
      errorMessage = (
        <div className="ui message negative">
          {errors.length > 0 ? <h3>Formulář není správně vyplněn</h3> : '' }
          <ul>
            {errors.map((error, i) => (
              <li key={i}>{error.message}</li>
            ))}
          </ul>
        </div>
      )
    }
    return (
      <WrappedForm
        {...this.props}
        errorMessage={errorMessage}
        handleServerErrors={this.handleServerErrors}
        submit={this.submit}
        {...this.state}
      />
    )
  }
}

export default FormValidation



// WEBPACK FOOTER //
// ./src/browser/components/FormValidation.js